import React, { useState, useEffect } from 'react'
import '../../plant-style.scss'
import Grid from '@mui/material/Grid'
import usePlantDetailsContentStyles from './styles'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import dayjs from 'dayjs'
import { expressURL } from '../../../../services/api'

const PlantDetailsContent = ({
  formik,
  plantData,
  dleted,
  handleCloseDelete,
  handleDeleteplant,
}) => {
  const classes = usePlantDetailsContentStyles()
  const [isDeleting, setIsDeleting] = useState(false)
  const [organizationName, setOrganizationName] = useState('')
  const [organizationAddress, setOrganizationAddress] = useState('')
  const [loadingOrgData, setLoadingOrgData] = useState(false)

  const today = new Date(plantData?.commissionDate)
  console.log('plantDatarrr', plantData)

  const year = today.getFullYear()
  const yearData = 2021

  // Fetch organization data from Zoho API
  useEffect(() => {
    const fetchOrganizationData = async () => {
      if (!plantData?.organizationId) {
        // Use fallback data from billerDetails
        setOrganizationName(plantData?.entity?.billerDetails?.entityName || '')
        setOrganizationAddress(plantData?.entity?.billerDetails?.entityAddress || '')
        return
      }

      setLoadingOrgData(true)
      try {
        const response = await fetch(
          `${expressURL}/api/zohobooks/fetch-invoice?organizationId=${plantData.organizationId}`,
          {
            method: 'GET',
          }
        )

        if (!response.ok) {
          throw new Error('Failed to fetch organization data')
        }

        const data = await response.json()

        if (data && data.data && data.data.organization) {
          const org = data.data.organization

          // Extract organization name
          const rawName = org.name || ''
          const cleanName = rawName
            .replace(/\s*\(Formerly known as.*?\)\s*/i, '')
            .trim()
          setOrganizationName(cleanName)

          // Extract organization address
          let fullAddress = org.address?.formatted_address || ''
          if (!fullAddress && org.address) {
            const addrParts = [
              org.address.address,
              org.address.street2,
              org.address.city,
              org.address.state,
              org.address.zipcode,
              org.address.country,
            ]
              .filter(Boolean)
              .join(', ')
            fullAddress = addrParts
          }

          setOrganizationAddress(fullAddress)
        } else {
          // Fallback to billerDetails if Zoho API doesn't return data
          setOrganizationName(plantData?.entity?.billerDetails?.entityName || '')
          setOrganizationAddress(plantData?.entity?.billerDetails?.entityAddress || '')
        }
      } catch (error) {
        console.error('Error fetching organization data from Zoho:', error)
        // Fallback to billerDetails on error
        setOrganizationName(plantData?.entity?.billerDetails?.entityName || '')
        setOrganizationAddress(plantData?.entity?.billerDetails?.entityAddress || '')
      } finally {
        setLoadingOrgData(false)
      }
    }

    fetchOrganizationData()
  }, [plantData?.organizationId, plantData?.entity?.billerDetails])

  const handleDeleteClick = async () => {
    setIsDeleting(true)
    try {
      await handleDeleteplant(plantData?.id)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={dleted}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Delete Plant'}</DialogTitle>
        <DialogContent>
          {isDeleting ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
                gap: 2,
              }}
            >
              <CircularProgress />
              <DialogContentText>
                Verifying and deleting plant...
              </DialogContentText>
            </Box>
          ) : (
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete your plant?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} disabled={isDeleting}>
            Disagree
          </Button>
          <Button
            onClick={handleDeleteClick}
            disabled={isDeleting}
            autoFocus
          >
            {isDeleting ? 'Deleting...' : 'Agree'}
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container spacing={2}>
        <Grid item xs={12} lg={4}>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Plant Name
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.plantName}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Project Code
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.projectCode}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Plant Location
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.plantLocation}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Plant Size
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.plantSizeKW}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Industry Type
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.industryType}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Longitude
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.longitude}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Latitude
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.latitude}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Tenure
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.tenure} Years</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} lg={4}>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Tariff
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.proposalType?.tariff}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Currency
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.currency}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Commission Date
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {dayjs(plantData?.commissionDate).format('DD-MM-YYYY')}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Completion Date
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {dayjs(plantData?.completionDate).format('DD-MM-YYYY')}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Plant Time Zone
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.plantTimeZone}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Sub Contractor Access
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {plantData?.subContractorAccess === true ? 'Yes' : 'No'}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Proposal Type
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.proposalType?.type}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Rate of Interest
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {plantData?.interestRate ? `${plantData.interestRate}%` : 'Nil'}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Organization Id
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {plantData?.organization
                  ? `${plantData.organization?.organizationCode}`
                  : 'Nil'}
              </span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} lg={4}>
          <div className="roof_list_h">ENTITY DETAILS</div>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Entity Name
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.entity?.entityName}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Designation
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.entity?.designation}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Organization Name
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {loadingOrgData ? (
                  <CircularProgress size={16} />
                ) : (
                  plantData?.organization?.organizationName || 'N/A'
                )}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Organization Address
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>
                {loadingOrgData ? (
                  <CircularProgress size={16} />
                ) : (
                  plantData?.organization?.address?.street || 'N/A'
                )}
              </span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Email ID
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>
                {Array.isArray(plantData?.entity?.primaryEmail) ? (
                  plantData.entity.primaryEmail.map((em, i) => (
                    <div key={i}>: {em}</div>
                  ))
                ) : (
                  <div>: {plantData?.entity?.primaryEmail || 'N/A'}</div>
                )}
              </span>
            </Grid>
          </Grid>

          {/* CC Email (plant-level) */}
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              CC Email
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>
                {Array.isArray(plantData?.entity?.ccEmail) ? (
                  plantData.entity.ccEmail.map((em, i) => (
                    <div key={i}>: {em}</div>
                  ))
                ) : (
                  <div>: {plantData?.entity?.ccEmail || 'N/A'}</div>
                )}
              </span>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Contact No.
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.entity?.primaryPhone}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              GST
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.entity?.gst}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              PAN Number
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData?.entity?.panNumber}</span>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="list_style">
            <Grid item xs={4} sm={3} lg={5} className="list_left">
              Total Roofs
            </Grid>
            <Grid item xs={8} sm={9} lg={7} className="list_right">
              <span>:&nbsp;</span>
              <span>{plantData && plantData?.roofDetails?.length}</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div className="brdr"></div>

      {plantData?.roofDetails?.map((data, index) => (
        <div key={data?.id || index} className="roof_bg">
          <div className="roof_head_btn">Roof {index + 1}</div>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <div className="roof_list_h">GENERAL</div>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Roof Location
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.roofLocation || 'N/A'}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  MAC ID
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.macId ||
                      data?.energyMeters?.[0]?.macId ||
                      data?.inverters?.[0]?.macId ||
                      'N/A'}
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Name
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.name}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Orientation
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.orientation}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Module Facing F1 & F2
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.f1ModuleFacing}, {data?.f2ModuleFacing}
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Tilt angle T1 & T2
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.t1TiltAngle}, {data?.t2TiltAngle}
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Azimuth A1 & A2
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.a1Azimuth}, {data?.a2Azimuth}
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Total Modules M1 & M2
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.m1Modules}, {data?.m2Modules}
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Capacity
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.capacity}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Datalogger Make
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.dataloggerMake}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Datalogger Model
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.dataloggerModel}</span>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={4}>
              <div className="roof_list_h">ENERGY METER</div>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Model
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters?.[0]?.model}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Make
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters?.[0]?.make}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Device Id
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters?.[0]?.deviceId || 'N/A'}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Slave ID:
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters[0]?.slaveId}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Scaling Factor
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters?.[0]?.scalingFactor}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  CT Ratio
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.energyMeters?.[0]?.ctRatio}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Dc Capacity
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>
                    {data?.energyMeters?.[0]?.meterConnectedDcCapacity}
                  </span>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={4}>
              <div className="roof_list_h">INVERTER</div>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Make
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.inverters?.[0]?.make || 'N/A'}</span>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Slave ID:
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>: {data?.inverters[0]?.slaveId}</span>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  Model
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.inverters?.[0]?.model}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  No. of Strings
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.inverters?.[0]?.noOfStrings}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  DC Capacity
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.inverters?.[0]?.dcCapacity}</span>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="list_style">
                <Grid item xs={4} sm={3} lg={5} className="list_left">
                  AC Capacity
                </Grid>
                <Grid item xs={8} sm={9} lg={7} className="list_right">
                  <span>:&nbsp;</span>
                  <span>{data?.inverters?.[0]?.acCapacity}</span>
                </Grid>
              </Grid>

              {/* Sensor Details */}
              {data?.sensors && data?.sensors?.length > 0 && (
                <>
                  <div className="roof_list_h" style={{ marginTop: '20px' }}>
                    SENSOR DETAILS
                  </div>
                  {data.sensors.map((sensor, sensorIndex) => (
                    <div key={sensor?.id || sensorIndex}>
                      <Grid container spacing={1} className="list_style">
                        <Grid item xs={4} sm={3} lg={5} className="list_left">
                          Sensor Name
                        </Grid>
                        <Grid item xs={8} sm={9} lg={7} className="list_right">
                          <span>:&nbsp;</span>
                          <span>{sensor?.name}</span>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className="list_style">
                        <Grid item xs={4} sm={3} lg={5} className="list_left">
                          Device ID
                        </Grid>
                        <Grid item xs={8} sm={9} lg={7} className="list_right">
                          <span>:&nbsp;</span>
                          <span>{sensor?.deviceId || 'N/A'}</span>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className="list_style">
                        <Grid item xs={4} sm={3} lg={5} className="list_left">
                          Slave ID:
                        </Grid>
                        <Grid item xs={8} sm={9} lg={7} className="list_right">
                          <span>:&nbsp;</span>
                          <span>{sensor?.slaveId}</span>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className="list_style">
                        <Grid item xs={4} sm={3} lg={5} className="list_left">
                          Make & Model
                        </Grid>
                        <Grid item xs={8} sm={9} lg={7} className="list_right">
                          <span>:&nbsp;</span>
                          <span>
                            {sensor?.make} - {sensor?.model}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className="list_style">
                        <Grid item xs={4} sm={3} lg={5} className="list_left">
                          Type
                        </Grid>
                        <Grid item xs={8} sm={9} lg={7} className="list_right">
                          <span>:&nbsp;</span>
                          <span>{sensor?.type}</span>
                        </Grid>
                      </Grid>
                    </div>
                  ))}
                </>
              )}
            </Grid>
          </Grid>
        </div>
      ))}
    </div>
  )
}

PlantDetailsContent.propTypes = {}

export default PlantDetailsContent
